(function() {
  const chatBtn = document.getElementById('chat-with-us');
  const nextBtn = document.getElementById('go-next-step');
  const mainContainer = document.getElementById('widget-main-container');
  const guidePanel = document.getElementById('guide-panel');
  const iframeWrapper = document.getElementById('iframe-wrapper');
  const theIframe = document.getElementById('JotFormIFrame-260252243614145');

  const FORM_ID = "260252243614145";
  const JOTFORM_DOMAIN = "https://form.jotform.com/";
  let isPanelOpen = false;
  
  function handleToggle() {
    if (!isPanelOpen) {
      mainContainer.style.display = 'block';
      isPanelOpen = true;
    } else {
      mainContainer.style.display = 'none';
      isPanelOpen = false;
      guidePanel.style.display = 'block';
      iframeWrapper.style.display = 'none';
    }
  }

  function handleShowForm(e) {
    if (e && !e.isTrusted && !e.detail) return;
    
    guidePanel.style.display = 'none';
    iframeWrapper.style.display = 'block'; 

    if (jotformHandlerReady && window.jotformEmbedHandler) {
      try {
        window.jotformEmbedHandler(`#JotFormIFrame-${FORM_ID}`, JOTFORM_DOMAIN);
      } catch (err) {
        console.error("Jotform handler error:", err);
      }
    } else {
      console.warn("Jotform handler not ready");
    }
  }

  chatBtn?.addEventListener('click', handleToggle);
  nextBtn?.addEventListener('click', handleShowForm);
})();
